import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { IButtonGroup, IColumn } from "../../../../Interfaces/filter";
import { UseRazon } from "./useRazon"
import { useBoolean } from "@fluentui/react-hooks";
import { IRazonEdit } from "../../../../Interfaces/auxiliar/IRazon";
import themeBase from "../../../../utils/theme/themeBase";
import { useState } from "react";
import { HeadingBar } from "../../../../components/generic/HeadingBar";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { PanelRazonInsertar } from "./RazonInsertar/PanelRazonInsertar";
import { PanelRazonEditar } from "./RazonEditar/PanelRazonEditar";
import { PanelRazonEliminar } from "./RazonEliminar/PanelRazonEliminar";
import { Button } from "@fluentui/react-components";
import { useIconsCatalogo } from "../../../../components/iconCatalog/common.useIconsCatalogo";
import { EditRegular, DeleteRegular } from "@fluentui/react-icons";
import { CommonHeaderComponent } from "../../../../components/generic/common.Header";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelSincronizarRazon } from "./RazonSincronizar/PanelSincronizarRazon";

const iconDetalleStyle: React.CSSProperties | undefined = {
  cursor: "pointer",
  color: "#0078d4",
};
export const Razon = () => {
  const { Icon } = useIconsCatalogo();
  const [isOpenRazon, { setTrue: openPanelRazon, setFalse: closePanelRazon }] = useBoolean(false);
  const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);

  const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
  const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
  const { items, filter, setFilter, loading, pagination, getRazones, handleResetUpdate, onChangeSearch, onChangeTake, _onkeyUpSearchTable } = UseRazon()
  const [item, setItem] = useState<IRazonEdit>({
    descripcion: "",
    codigo: "",
    estadoId: "",
    razonId: ""
  })
  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD2,
      text: "Sincronizar",
      onClick: () => {
        openPanelSYNC()
      },
    },
  
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate()
      },
    }
  ];
  
  function renderOpciones(item: IRazonEdit) {
    return (
      <>
        <TooltipHost content={`Editar`}>
          <Button
            size="large"
            icon={<EditRegular />}
            className={themeBase.classNamesIcon.iconFont}
            style={iconDetalleStyle}
            onClick={() => {
              setItem(item)
              openPanelEditar()
            }}
          />
        </TooltipHost>
        <TooltipHost content={`Quitar`}>
          <Button
            size="large"
            icon={<DeleteRegular />}
            className={themeBase.classNamesIcon.iconFont}
            style={iconDetalleStyle}
            onClick={() => {
              setItem(item)
              openPanelEliminar()
            }}
          />
        </TooltipHost>
      </>
    );
  }
  const _columns = [
    {
      key: "codigo",
      name: "Código",
      fieldName: "codigo",
      minWidth: 50,
      maxWidth: 100,
    },
    {
      key: "descripcion",
      name: "Descripción",
      fieldName: "descripcion",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      key: "categoria",
      name: "Categoría",
      fieldName: "categoria",
      minWidth: 200,
      maxWidth: 200,
    },
    {
      key: "fechaCreacion",
      name: "Fecha de Creación",
      fieldName: "fechaCreacion",
      minWidth: 150,
      maxWidth: 150,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 100,
      maxWidth: 100,
      onRender: (item: any) => renderOpciones(item)


    }
  ]

  return (
    <>
      <CabeceraTable
        Titulo={"Razón"}
        SubTitulo={"Gestión de Razones"}
        placeholder="Buscar por Código"
        componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />
      <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />
      <PanelRazonInsertar isOpen={isOpenRazon} onDismiss={closePanelRazon} reload={handleResetUpdate} />
      <PanelRazonEditar item={item} isOpen={isOpenEditar} onDismiss={closePanelEditar} reload={handleResetUpdate}></PanelRazonEditar>
      <PanelSincronizarRazon isOpen={isOpenSYNC} onDismiss={closePanelSYNC} reload={handleResetUpdate}/>
      {isOpenEliminar && <PanelRazonEliminar item={item} isOpen={isOpenEliminar} onDismiss={closePanelEliminar} reload={handleResetUpdate}></PanelRazonEliminar>}
    </>
  )
}